import PracticePageV2 from "@/components/site/v2/PracticePageV2";
import { BRAND_PAGE as page } from "@/data/brandPage";

const CAP_URL = "/capabilities/brand-marketing-communications";

export default function BrandPage() {
  const explorerItems = page.offers.map((o) => ({
    name: o.name,
    outcome: o.lead,
    body: o.body,
    covers: o.list,
    link: o.slug ? { to: `${CAP_URL}/${o.slug}`, label: `Explore ${o.name}` } : undefined,
  }));

  return (
    <PracticePageV2
      testid="brand-page"
      page={page}
      capUrl={CAP_URL}
      image="/photos/practice-hero-brand.jpg"
      imageAlt="Indian team reviewing a colorful market analytics dashboard on a large screen"
      heroDescription="From positioning and identity to campaigns and communications, we connect brand building with commercial growth."
      heroTagline="Build brands customers choose."
      challenges={page.challengeQuestions.map((q) => ({ title: q, to: "#capabilities" }))}
      explorerItems={explorerItems}
      deliverables={page.deliverGroups.flatMap((g) => g.items)}
      outcomes={page.outcomes}
      frameworkHeadline={page.approachLead}
    />
  );
}
